import AboutHero from '../sections/About/AbtHero'
import AboutContent from '../sections/About/AboutContent'
import KeyFeatures from '../sections/About/KeyFeatures'
import WhyTravelers from '../sections/About/WhyTravelers'
import Testimonials from '../sections/home/Testimonials'
import AbtService from '../sections/About/AbtService'
import Footer from '../components/Footer'


export default function About() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-white">
      <AboutHero />
      <AboutContent />
      <AbtService />
      <Testimonials/>
      <WhyTravelers />
      <KeyFeatures />
    
      <div aria-hidden="true" className="h-[78px] bg-white" />
      <Footer />
    </main>
  )
}